var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.652,
    height: 23.638,
    viewBox: "0 0 23.652 23.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_3_",
    "data-name": "home (3)",
    d: "M22.786,8.938,15.311,1.462a4.935,4.935,0,0,0-6.969,0L.866,8.938A2.935,2.935,0,0,0,0,11.028V20.7a2.956,2.956,0,0,0,2.956,2.956H20.7A2.956,2.956,0,0,0,23.652,20.7V11.028A2.935,2.935,0,0,0,22.786,8.938Zm-8,12.75H8.869V17.811a2.956,2.956,0,1,1,5.913,0Zm6.9-.985a.985.985,0,0,1-.985.985H16.753V17.811a4.927,4.927,0,1,0-9.855,0v3.877H2.956a.985.985,0,0,1-.985-.985V11.028a.993.993,0,0,1,.289-.7L9.735,2.858a2.964,2.964,0,0,1,4.182,0l7.475,7.476a.993.993,0,0,1,.289.694Z",
    transform: "translate(0 -0.021)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0c44dfaa2187978845154b2c32fdbdf4.svg";
export { ForwardRef as ReactComponent };